const { icons } = require("./selection.json");

export const iconNames = () => {
  return icons.map((icon) => {
    return icon.properties.name;
  });
};

export const getIcons = () => {
  const iconMap = new Map();
  for (const i in icons) {
    const {
      properties: { name },
      icon: { paths },
    } = icons[i];
    iconMap.set(name, paths);
  }
  return iconMap;
};
